import { FC, useEffect } from "react";
import { clearSession } from "../../CookieHandler";

export const LogoutPage: FC = () => {
  useEffect(() => {
    clearSession();
    window.location.replace('/member/sign-in');
  }, []);

  return null;
}
